import IndentForm from '@/modules-v2/indent/views/create-update/index';
import Edit from '@/modules-v2/indent/views/create-update/editshipment';

const indent = [
  {
    path: '/indent/create/:type',
    name: 'CreateOrder',
    component: IndentForm,
    meta: {
      title: 'Indent Create',
      requiresAuth: true,
    },
  },
  {
    path: '/indent/:orderId/:type/edit/',
    name: 'editOrder',
    component: IndentForm,
    props: true,
    meta: {
      title: 'Edit Indent',
      requiresAuth: true,
    },
  },
  {
    path: '/indent/:orderId/:type/change-truck-type/',
    name: 'changeTruckType',
    component: IndentForm,
    props: true,
    meta: {
      title: 'Change Truck Type',
      allowChangeTruck: true,
      requiresAuth: true,
    },
  },
  {
    path: '/indent/:orderId/:type/indent-draft/',
    name: 'indentDraft',
    component: IndentForm,
    meta: {
      title: 'Create Indent',
      isFromDraft: true,
      requiresAuth: true,
    },
  },
  {
    path: '/indent/:orderId/:type/indent-clone/',
    name: 'indentClone',
    component: IndentForm,
    meta: {
      title: 'Clone Indent',
      isFromClone: true,
      requiresAuth: true,
    },
  },
  {
    path: '/indent/:orderId/hach-edit/',
    name: 'EditHach',
    component: Edit,
    meta: {
      title: 'Edit Indent',
      requiresAuth: true,
    },
  },
];

export default indent;
